import React from 'react'
import { Typography } from 'antd'
import { CompletedPurchaseOrder } from '../../../types/purchaseOrder'

const { Text } = Typography

interface Props {
  purchaseOrder: CompletedPurchaseOrder
}

export const PurchaseOrderTerms: React.FC<Props> = ({ purchaseOrder }) => {
  return (
    <>
      {purchaseOrder.terms && (
        <div className="border-t pt-8">
          <Text strong className="block mb-4">
            Terms and Conditions
          </Text>

          <div className="space-y-2 text-sm text-gray-600">
            <Text className="block whitespace-pre-line">
              {purchaseOrder.terms}
            </Text>
          </div>
        </div>
      )}
    </>
  )
}
